import { Game, GameFeedback, GameList, PublishedGameDetail, GameRating} from '@/_models/Game';
import { GameService, fetchAuthKey } from "@/services/GameService";
import { Helper } from "@/utils/Helper";

interface GameObj {
  title: string;
  id: string;
  name: string;
  version: string;
  expiry: string;
  updatedDate: string;
  updatedTime: string;
  username: string;
  status: number;
}

export class GameUtils{

  static async fetchPublishedGame (gameId: string):Promise<Game> {

    const gm = new GameService();
    const gamesDetail:Game = await gm.getPublishedGame(gameId);
    return gamesDetail;
  }

  static async fetchGenreCount():Promise<any>{
    const gm =new GameService();
    const genreCount:any = await gm.getGenreCount();
    return genreCount;
  }

  static async fetchGenrePublishedGame (category: string):Promise<PublishedGameDetail[]> {
  try{
    const gm = new GameService();
    const games = await gm.getGenrePublishedGames(category);
    return games;
  }catch(error){
    Helper.endpointErrorHandling(error)
  }
}

  static async fetchDeveloperPublishedGame (developerID: string):Promise<PublishedGameDetail[]> {
  try{
    const gm = new GameService();
    const games = await gm.getDeveloperPublishedGames(developerID);
    return games;
  }catch(error){
    Helper.endpointErrorHandling(error)
  }
}

  static async fetchDeveloperPopularityCount (developerID: string):Promise<PublishedGameDetail[]> {
  try{
    const gm = new GameService();
    const games = await gm.getDeveloperPopularityCount(developerID);
    return games;
  }catch(error){
    Helper.endpointErrorHandling(error)
  }
}

  static async fetchDeveloperFavoritesCount (developerID: string):Promise<PublishedGameDetail[]> {
  try{
    const gm = new GameService();
    const games = await gm.getDeveloperFavouritesCount(developerID);
    return games;
  }catch(error){
    Helper.endpointErrorHandling(error)
  }
}

static async fetchFeaturedGames():Promise<any> {
  try{
    const gm = new GameService();
    const games = await gm.getFeaturedGames();
    return games;
  }catch(error){
    Helper.endpointErrorHandling(error)
  }
}


  static async fetchAllPublishedGames():Promise<PublishedGameDetail[]> {
    try{
      const gm = new GameService();
      const games = await gm.getAllPublishedGames();
      return games;
    }catch(error){
      Helper.endpointErrorHandling(error)
    }
  }

  static async fetchRatingList(gameId: string):Promise<any>{
    const gm =new GameService();
    const ratingList:any = await gm.getRatingList(gameId);
    return ratingList;
  }

  static async feedbackGame(gameId: string, feedback: string): Promise<GameFeedback>{

    const gm = new GameService();
    const feedbackGame:GameFeedback = await gm.feedbackGame(gameId, feedback);
    return feedbackGame;
  }

  static async fetchFavouriteGame():Promise<any> {
    try{
      const gm = new GameService();
      const favourites = await gm.getFavouriteList();
      return favourites;
    }catch(error){
      Helper.endpointErrorHandling(error)
    }
  }

  static async favouriteGame(gameId: string):Promise<any>{
    const gm =new GameService();
    const favouriteGame:any = await gm.favouriteGame(gameId);
    return favouriteGame;
  }

  static async unfavouriteGame(gameId: string):Promise<any>{
    const gm =new GameService();
    const unfavouriteGame:any = await gm.unfavouriteGame(gameId);
    return unfavouriteGame;
  }

  static async rateGame(gameId: string, rates?: string):Promise<GameRating>{
    const gm = new GameService();
    const rateGame:GameRating = await gm.rateGame(gameId, rates);
    return rateGame;
  }

  static async fetchAccessTokenKey(gameId: string): Promise<fetchAuthKey>{
    const gm = new GameService();
    const authKey = await gm.getAccessTokenKey(gameId);
    return authKey;
  }
}